import React, { Component } from 'react';

class Contact extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">

         <div className="row section-head">

            <div className="two columns header-col" >

               <h1></h1>

            </div>

            <div className="ten columns">

                  <p className="lead">{message}</p>

            </div>

         </div>

         <div className="row">
               <div className="widget widget_contact">
					   <h4>Address and Contact details</h4>
					   <p className="address">
						   {name}<br />
						   <span>{phone}<br/></span>
               <span><a href="mailto:b.anikesh@gmail.com">b.anikesh@gmail.com</a></span>
					   </p>
				   </div>
      </div>
   </section>
    );
  }
}

export default Contact;
